(function() {
  'use strict';

  var KLAVIYO_ACCOUNT = 'Qv3KXW';
  var SUBSCRIBE_URL = 'https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + KLAVIYO_ACCOUNT;
  var KLAVIYO_API_REVISION = '2024-10-15';

  // Build and insert the modal HTML once
  var overlay = document.createElement('div');
  overlay.className = 'bis-modal-overlay';
  overlay.innerHTML =
    '<div class="bis-modal">' +
      '<button type="button" class="bis-modal__close" aria-label="Close">&times;</button>' +
      '<h3 class="bis-modal__headline"></h3>' +
      '<p class="bis-modal__body">Register to receive a notification when this item comes back in stock.</p>' +
      '<form class="bis-modal__form">' +
        '<div>' +
          '<label class="bis-modal__label" for="bis-email">Email</label>' +
          '<input class="bis-modal__input" id="bis-email" type="email" placeholder="Email address" required>' +
        '</div>' +
        '<button type="submit" class="bis-modal__submit">Get first dibs when this is back in stock.</button>' +
      '</form>' +
      '<p class="bis-modal__message" style="display:none;"></p>' +
    '</div>';
  document.body.appendChild(overlay);

  var headline = overlay.querySelector('.bis-modal__headline');
  var form = overlay.querySelector('.bis-modal__form');
  var emailInput = overlay.querySelector('#bis-email');
  var submitBtn = overlay.querySelector('.bis-modal__submit');
  var message = overlay.querySelector('.bis-modal__message');
  var closeBtn = overlay.querySelector('.bis-modal__close');

  var currentVariantId = null;

  function openModal(productTitle, variantTitle, variantId, customerEmail) {
    currentVariantId = variantId;
    headline.textContent = variantTitle && variantTitle !== 'Default Title'
      ? productTitle + ' — ' + variantTitle
      : productTitle;
    emailInput.value = customerEmail || '';
    form.style.display = '';
    message.style.display = 'none';
    message.textContent = '';
    message.className = 'bis-modal__message';
    submitBtn.disabled = false;
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    emailInput.focus();
  }

  function closeModal() {
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
    currentVariantId = null;
  }

  // Close handlers
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-active')) closeModal();
  });

  // Form submit
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var email = emailInput.value.trim();
    if (!email || !currentVariantId) return;

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting...';

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + currentVariantId
            }
          }
        }
      }
    };

    fetch(SUBSCRIBE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': KLAVIYO_API_REVISION
      },
      body: JSON.stringify(payload)
    })
    .then(function(res) {
      // Klaviyo returns 202 Accepted on success, no body
      if (!res.ok) throw new Error('Request failed with status ' + res.status);
      return res;
    })
    .then(function() {
      form.style.display = 'none';
      message.className = 'bis-modal__message bis-modal__message--success';
      message.textContent = "You're in! We'll let you know when it's back.";
      message.style.display = '';
    })
    .catch(function() {
      message.className = 'bis-modal__message bis-modal__message--error';
      message.textContent = 'Something went wrong. Please try again.';
      message.style.display = '';
      submitBtn.disabled = false;
      submitBtn.textContent = 'Get first dibs when this is back in stock.';
    });
  });

  // Listen for clicks on any waitlist trigger
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-bis-trigger]');
    if (!trigger) return;

    e.preventDefault();
    var productTitle = trigger.getAttribute('data-bis-product-title') || '';
    var variantTitle = trigger.getAttribute('data-bis-variant-title') || '';
    var variantId = trigger.getAttribute('data-bis-variant-id') || '';
    var customerEmail = trigger.getAttribute('data-bis-customer-email') || '';
    openModal(productTitle, variantTitle, variantId, customerEmail);
  });
})();
